// src/pages/ContactUs.js
import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";

export default function ContactUs() {
  /* ── status banner ── */
  const [status, setStatus] = useState(null);   // {ok:boolean,msg:string}|null
  const form = useRef();                        // ref to <form>

  /* ── submit handler ── */
  const handleSubmit = async (e) => {
    e.preventDefault();
    const body = new FormData(form.current);

    try {
      const res = await fetch(
        "https://wications.com/contact-handler.php", // ← PHP endpoint
        { method: "POST", body }
      );

      if (res.ok) {
        setStatus({ ok: true, msg: "Thanks — your message was sent!" });
        e.target.reset();
      } else {
        throw new Error(await res.text());
      }
    } catch (err) {
      console.error(err);
      setStatus({
        ok: false,
        msg: "Sorry, something went wrong. Please try again later.",
      });
    }
  };

  return (
    <>
      {/* ── Breadcrumb ───────────────────────────── */}
      <div className="breadcumb-area clearfix auto-init">
        <div className="breadcumb-content">
          <div className="container h-100">
            <div className="row h-100 align-items-center">
              <div className="col-12">
                <nav
                  aria-label="breadcrumb"
                  className="breadcumb--con text-center"
                >
                  <h2 className="w-text title wow fadeInUp" data-wow-delay="0.2s">
                    Contact Us
                  </h2>
                  <ol
                    className="breadcrumb justify-content-center wow fadeInUp"
                    data-wow-delay="0.4s"
                  >
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Contact Us
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Intro Section */}
      <section className="section-padding-100 contact_intro_area">
        <div className="container">
          <div className="section-heading text-center">
            <span>Need Professional Translations?</span>
            <h2 className="d-blue bold fadeInUp" data-wow-delay="0.3s">
              Get In Touch With Ardent Translations
            </h2>
            <p className="fadeInUp" data-wow-delay="0.4s">
              Whether you need document translation, website localization or
              multimedia subtitling, our experts are here to help. Reach out
              today for a custom quote and fast turnaround.
            </p>
          </div>
        </div>
      </section>

         {/* Contact Info Blocks */}
      <section className="section-padding-50 contact_info_area">
        <div className="container">
          <div className="row text-center">
            {[
              { icon: "fa-phone", title: "Phone", text: "+91 89378 33310" },
              {
                icon: "fa-envelope",
                title: "Email",
                text: "info@ardenttranslations.com",
              },
              {
                icon: "fa-map-marker",
                title: "Location",
                text: "45 ICON, Baner Road, Pune 411045, India",
              },
            ].map((item, i) => (
              <div
                key={i}
                className="col-12 col-md-4 wow fadeInUp"
                data-wow-delay={`${0.2 + 0.2 * i}s`}
              >
                <div className="contact-info-box">
                  <i className={`fa ${item.icon} fa-2x mb-3`}></i>
                  <h5>{item.title}</h5>
                  <p>{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Contact Form ────────────────────────── */}
      <section className="section-padding-100 contact_us_area" id="contact">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-10 col-lg-8">
              <div className="contact_form">
                <form
                  ref={form}
                  onSubmit={handleSubmit}
                  id="main_contact_form"
                  noValidate
                >
                  <div className="row">
                    {/* banner */}
                    {status && (
                      <div className="col-12">
                        <p className={status.ok ? "text-success" : "text-danger"}>
                          {status.msg}
                        </p>
                      </div>
                    )}

                    {/* fields */}
                    {[
                      { name: "name", label: "Name", type: "text", half: true },
                      { name: "email", label: "Email", type: "email", half: true },
                      { name: "subject", label: "Subject", type: "text", half: false },
                      { name: "message", label: "Message", type: "textarea", half: false },
                    ].map((f, i) => (
                      <div key={i} className={`col-12 ${f.half ? "col-md-6" : ""}`}>
                        <div className="group wow fadeInUp" data-wow-delay={`${0.2 + 0.1 * i}s`}>
                          {f.type === "textarea" ? (
                            <textarea name={f.name} required />
                          ) : (
                            <input type={f.type} name={f.name} required />
                          )}
                          <span className="highlight"></span>
                          <span className="bar"></span>
                          <label>{f.label}</label>
                        </div>
                      </div>
                    ))}

                    <div className="col-12 text-center wow fadeInUp" data-wow-delay="0.6s">
                      <button type="submit" className="btn info-btn">
                        Send Message
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

          {/* Map Area */}
      <section className="map-area">
        <div className="container-fluid p-0">
          <iframe
            src="https://maps.google.com/maps?q=45%20ICON%20Baner%20Road%20Pune%20411045%20India&t=&z=13&ie=UTF8&iwloc=&output=embed"
            width="100%"
            height="400"
            frameBorder="0"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
          ></iframe>
        </div>
      </section>
    </>
  );
}
